import videojs from 'video.js';

const ModalDialog = videojs.getComponent('ModalDialog');
const Component = videojs.getComponent('Component');
const dom = videojs.dom || videojs;

/**
 * @typedef {Object} RestrictionListItem
 * @property {string} icon
 * @property {string} title
 * @property {string} subtitle
 */

/**
 * @typedef {Object} Options
 * @property {Array<RestrictionListItem>} restrictionList
 * @property {string} urlToAuth
 * @property {boolean} isUserAuthorized
 */

class RestrictionModalDialog extends ModalDialog {
  /**
   * @param {videojs.Player} player
   * @param {Options} options
   */
  constructor(player, options) {
    super(player, options);

    this.getAccess = () => {};

    this.addClass('vjs-restriction__info-modal-dialog');
    this.addContent();
  }

  addContent() {
    const titleEl = dom.createEl('div', {
      innerText: 'С подпиской — интереснее!',
      className: 'vjs-restriction__info-title'
    });

    const closeEl = dom.createEl('span', {
      className: 'vjs-restriction__close-modal'
    });
    closeEl.onclick = () => this.hide();

    const listEl = dom.createEl('ul', {
      className: 'vjs-restriction__info-list'
    });

    const listItemsEl = this.options_.restrictionList.map(({ icon, title, subtitle }) => {
      const listItemEl = dom.createEl('li', {
        className: 'vjs-restriction__info-item',
      }, {
        'data-type': icon
      });

      const iconEl = dom.createEl('div', {
        className: `vjs-restriction__info-item-icon vjs-restriction__info-item-icon_${icon}`
      });

      const contentWrapperEl = dom.createEl('div', {
        className: 'vjs-restriction__info-item-wrapper'
      });

      const titleEl = dom.createEl('h3', {
        className: 'vjs-restriction__info-item-title',
        innerHTML: title // innerHTML, т.к. в строке используется неразрывный пробел (&nbsp;) для форматирования.
      });

      const subtitleEl = dom.createEl('p', {
        className: 'vjs-restriction__info-item-subtitle',
        innerText: subtitle
      });

      contentWrapperEl.append(titleEl, subtitleEl);
      listItemEl.append(iconEl, contentWrapperEl);

      return listItemEl;
    });

    listEl.append(...listItemsEl);

    const buttonEl = dom.createEl('button', {
      className: 'vjs-restriction__info-button-get-access',
      innerText: 'получить доступ'
    });
    buttonEl.onclick = async () => {
      if (this.options_.isUserAuthorized) {
        this.hide();
        this.getAccess();
      } else {
        this.player().trigger('RestrictionModalDialog/login_start');
        window.parent.location.href = this.options_.urlToAuth;
      }
    };

    this.fillWith([titleEl, closeEl, listEl, buttonEl]);
  }

  toggleDisplay() {
    this.player().toggleClass('vjs-showing-settings');
    this.toggleClass('vjs-hidden');
  }

  show() {
    this.player().addClass('vjs-showing-settings');
    this.removeClass('vjs-hidden');
  }

  hide() {
    this.player().removeClass('vjs-showing-settings');

    if (!this.hasClass('vjs-hidden')) {
      this.addClass('vjs-hidden');
    }
  }

  onGetAccess(getAccessCallback) {
    this.getAccess = getAccessCallback;
  }
}

Component.registerComponent('restrictionModalDialog', RestrictionModalDialog);